import Layout from "../../components/Layout";
import { Helmet } from "react-helmet-async";
import {
  FiTruck,
  FiMapPin,
  FiPackage,
  FiClock,
  FiSettings,
  FiActivity,
  FiAlertCircle,
  FiTrendingUp,
  FiUsers,
} from "react-icons/fi";

const ModuleLogistics = () => {
  const trackCTA = () => {
    if (typeof window !== "undefined" && window.gtag) {
      window.gtag("event", "click", {
        event_category: "CTA",
        event_label: "Sign Up - Logistics Page",
      });
    }
  };

  return (
    <Layout>
      <Helmet>
        <title>Logistics | RedERP</title>
        <meta
          name="description"
          content="Optimize delivery, fleet management, and supply chain workflows with the RedERP Logistics module."
        />
      </Helmet>

      {/* Hero Block */}
      <section className="bg-gradient-to-br from-[rgb(84,13,14)] to-black text-white">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-10 relative">
          {/* Text */}
          <div className="flex-1 text-left mt-16">
            <h1 className="text-4xl font-bold mb-4">Logistics & Fleet Management</h1>
            <p className="mb-6 text-sm sm:text-base">
              Coordinate deliveries, track vehicle performance, and manage supply chain flows — all within one unified platform.
            </p>
            <a
              href="https://app.rederp.pro/sign-up"
              target="_blank"
              rel="noopener noreferrer"
              onClick={trackCTA}
              className="inline-block bg-white text-primary font-semibold px-6 py-3 rounded-full hover:bg-gray-100"
            >
              Get Started Now
            </a>
          </div>

          {/* Image */}
          <div className="flex-1 hidden md:flex justify-end mt-12 mb-0">
            <img
              src="/assets/images/truck.png"
              alt="Logistics Illustration"
              className="w-[420px] lg:w-[420px] xl:w-[420px] h-[310px] object-contain"
            />
          </div>
        </div>
      </section>

      {/* Feature List */}
      <section className="py-20 px-6 bg-white">
        <div className="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 text-left">
          {[
            {
              icon: <FiTruck size={24} />,
              title: "Fleet Tracking",
              desc: "Monitor vehicle usage, fuel consumption, and location status in real-time.",
            },
            {
              icon: <FiMapPin size={24} />,
              title: "Route Optimization",
              desc: "Plan optimal delivery routes based on live traffic and location data.",
            },
            {
              icon: <FiPackage size={24} />,
              title: "Shipment Lifecycle",
              desc: "Track shipments from origin to delivery with scan points and status updates.",
            },
            {
              icon: <FiClock size={24} />,
              title: "Delivery Scheduling",
              desc: "Manage delivery windows, proof of delivery, and route time tracking.",
            },
            {
              icon: <FiSettings size={24} />,
              title: "Carrier Integration",
              desc: "Integrate with third-party logistics carriers or manage your own fleet.",
            },
            {
              icon: <FiActivity size={24} />,
              title: "Real-Time Alerts",
              desc: "Get notified for delays, route deviations, and missed delivery attempts.",
            },
            {
              icon: <FiTrendingUp size={24} />,
              title: "Logistics Analytics",
              desc: "Analyze on-time rates, vehicle utilization, and cost per shipment.",
            },
            {
              icon: <FiUsers size={24} />,
              title: "Driver Management",
              desc: "Assign routes, monitor hours, and link activity with performance reports.",
            },
            {
              icon: <FiAlertCircle size={24} />,
              title: "Incident Reporting",
              desc: "Capture logistics incidents and assign follow-ups with traceability.",
            },
          ].map((item, i) => (
            <div
              key={i}
              className="p-6 bg-gray-50 border border-gray-200 rounded-xl shadow-sm hover:shadow-md transition-all"
            >
              <div className="flex items-center gap-3 text-primary mb-3">
                {item.icon}
                <h3 className="font-bold">{item.title}</h3>
              </div>
              <p className="text-sm text-gray-600">{item.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Final CTA */}
      <section className="py-20 bg-gradient-to-br from-[rgb(84,13,14)] to-black text-white text-center">
        <div className="max-w-xl mx-auto px-6">
          <h3 className="text-3xl font-bold mb-4">Digitize Your Delivery Operations</h3>
          <p className="mb-6">Start your 7-day free trial. No credit card required.</p>
          <a
            href="https://app.rederp.pro/sign-up"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block bg-white text-primary font-semibold px-6 py-3 rounded-full hover:bg-gray-100"
          >
            Try Logistics Module
          </a>
        </div>
      </section>
    </Layout>
  );
};

export default ModuleLogistics;
